import axios from 'axios'
import constants from '@/assets/js/constants.js'

const state = {
    transferPurposes: [],
    documentCategories: []
};

const getters = {
    allTransferPurposes: state => state.transferPurposes,
    allDocumentCategories: state => state.documentCategories
};

const actions = {
    async fetchTransferPurposes({ commit }, callbackFunction)
    {
        axios.get(constants.baseApiUrl + 'Lookups/get-all-purposes')
            .then(res => 
            {
                commit('setTransferPurposes', res.data);
                constants.purposes = res.data;
                if (callbackFunction != null)
                    callbackFunction()
            })
            .catch(err => console.log('from lookups.js, error is ' + err));
    },
    async fetchDocumentCategories({ commit }, callbackFunction)
    {
        axios.get(constants.baseApiUrl + 'Lookups/get-all-Categories')
            .then(res => 
            {
                commit('setDocumentCategories', res.data);

                if (callbackFunction != null)
                    callbackFunction()
            })
            .catch(err => console.log('from lookups.js, error is ' + err));
    },
};

const mutations = {
    setTransferPurposes: (state, transferPurposes) => (state.transferPurposes = transferPurposes),
    setDocumentCategories: (state, documentCategories) => (state.documentCategories = documentCategories)
};

export default {
    state,
    getters,
    actions,
    mutations
};